import classNames from 'classnames';

function DragAndDropIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={classNames('flex items-center', className)} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10 16C10 14.8954 10.8954 14 12 14C13.1046 14 14 14.8954 14 16C14 17.1046 13.1046 18 12 18C10.8954 18 10 17.1046 10 16Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17 16C17 14.8954 17.8954 14 19 14C20.1046 14 21 14.8954 21 16C21 17.1046 20.1046 18 19 18C17.8954 18 17 17.1046 17 16Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3 16C3 14.8954 3.89543 14 5 14C6.10457 14 7 14.8954 7 16C7 17.1046 6.10457 18 5 18C3.89543 18 3 17.1046 3 16Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9C14 10.1046 13.1046 11 12 11C10.8954 11 10 10.1046 10 9Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M17 9C17 7.89543 17.8954 7 19 7C20.1046 7 21 7.89543 21 9C21 10.1046 20.1046 11 19 11C17.8954 11 17 10.1046 17 9Z'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3 9C3 7.89543 3.89543 7 5 7C6.10457 7 7 7.89543 7 9C7 10.1046 6.10457 11 5 11C3.89543 11 3 10.1046 3 9Z'
        />
      </svg>
    </span>
  );
}

export default DragAndDropIcon;
